import { FilterValueType } from "@/components/StructuredSearch/config/structured-search-schema";
import type { Filter } from "@/components/StructuredSearch/config/types";
import { VersionedEntityKind } from "@/components/StructuredSearch/config/versioned-entity-config";
import { formatVersionedEntityDisplayLabel } from "@/components/StructuredSearch/config/versioned-entity-utils";

interface BuildWorkflowVersionLockedFiltersInput {
  workflowId?: string;
  workflowName?: string;
  workflowVersionNumber?: number;
}

export const buildWorkflowVersionLockedFilters = ({
  workflowId,
  workflowName,
  workflowVersionNumber,
}: BuildWorkflowVersionLockedFiltersInput): Filter[] => {
  if (!workflowId || !workflowName || workflowVersionNumber === undefined) {
    return [];
  }

  const workflowIdNumber = Number(workflowId);
  if (!Number.isFinite(workflowIdNumber)) {
    return [];
  }

  return [
    {
      id: `workflow-${workflowIdNumber}-version-${workflowVersionNumber}`,
      field: "trace_workflow_ids",
      type: FilterValueType.Enum,
      operator: "contains",
      value: {
        workflow_id: workflowIdNumber,
        workflow_version_number: workflowVersionNumber,
      },
      valueDisplay: formatVersionedEntityDisplayLabel(
        VersionedEntityKind.Workflow,
        workflowName,
        workflowVersionNumber,
      ),
    },
  ];
};
